
import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import "../assets/css/login.css";
import { Link } from "react-router-dom";
import config from "../api/config";
export default function Register() {
  const navigator = useHistory();
  // fields
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  // err
  const [error, setError] = useState(false);
  // register
  const registerUser = async (body) => {
    try {
      await config.post(`/api/auth/v1/register`, body);

      localStorage.setItem("name", username);
      localStorage.removeItem("password");
      navigator.push({
        pathname: `/verify`,
        search: "?mode=verify",
      });
    } catch (error) {
      setError(true);
    }
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    await registerUser({
      phoneNumber: username,
      password,
      lastName,
      firstName,
    });
  };
  return (
    <div className="login_container" style={{ height: "100vh" }}>
      <div className="wrapper">
        <header>Регистрация</header>
        <form action="#" onSubmit={handleSubmit}>
          <div className="field email">
            <div className="input-area">
              <input
                type="text"
                placeholder="Имя"
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="field email">
            <div className="input-area">
              <input
                type="text"
                placeholder="Фамилия"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="field email">
            <div className="input-area">
              <input
                type="text"
                placeholder="Номер телефона"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
              />{" "}
              {/* <i
                className="error error-icon fas fa-exclamation-circle"
                style={{ display: error ? "block" : "none" }}
              ></i> */}
            </div>
            <div
              className="error error-txt"
              style={{ display: error ? "block" : "none" }}
            >
              Это пользователь уже существует
            </div>
          </div>
          <div className="field password">
            <div className="input-area">
              <input
                type="password"
                placeholder="Пароль"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <input type="submit" value="Регистрация" />
        </form>
        <div className="sign-txt">
          Вы уже пользователь ? <br />
          <Link to="/">Страница авторизации</Link>
        </div>
      </div>
    </div>
  );
}
